import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from "../../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from "../../services/tutorial.service";
import Demo from "../crop/Demo";
import { teamlistData, actlistData, setisfirsttime } from "../../actions/index";
import { teamdefaultLogo } from "../../constants/Images";
import { getAlpha } from "../../Helpers/Helpers";
import $ from "jquery";
import { getDatabase, ref, remove, onValue,push, set, update } from "firebase/database";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper from '../utils/Demo'
import { FirebaseContext } from '../../FirebaseContext';

function Addteam(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setteamlistData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const [logo, setLogo] = useState();
  const history = useHistory({ forceRefresh: true });
  const loginuser = useSelector((state) => state.setUserlog);
  const [cropData, setCropData] = useState("#");
  const aid = localStorage.getItem("auction_id");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [croppedImage, setCroppedImage] = useState("");
  const [admin_id, setadminid] = useState(localStorage.getItem('admin_id'));
  const [admin_name, setadmin_name] = useState(localStorage.getItem('admin_name'));
  const updtoken = useSelector((state) => state.updtoken);

  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);

  let logo_pic = "";
  var savenew = 0;
  const onSubmit = (values) => {
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    values["logo_pic"] = croppedImage;

    DataService.addTeam(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // console.log(response.data)
        if (response.success == true) {
          const db = getDatabase();
          // console.log("team added trigger")
          set(ref(db, 'map/info/' + aid), {
            "type": "2", "upd": "1", 'id': response.data.tmid, "detail": {
              "tmid": response.data.tmid,
              "name": values.name,
              "srtname": values.srtname,
              "srtkey": values.srtkey,
              "logo": response.data.new.logo
            }, "tkn": updtoken
          });
          let submitdata = [response.data.new];
          let responsedata = {};
          if (getpageData == 0) {
            responsedata = {
              responsedata: {
                path: response.data.path,
                aid: aid,
                list: [...submitdata],
              },
            };
          } else {
            responsedata = {
              responsedata: {
                path: response.data.path,
                aid: aid,
                list: [...submitdata, ...getpageData.responsedata.list],
              },
            };
            if (getpageData.responsedata.list.length == 2) {
              // console.log('way 1')
              var data = {};
              data['work5'] = 3;
              update(ref(db, 'map/info/datastatus/' + aid), data);
              var workhistory = {};
              var currentTime = new Date();  // Store the current time in a variable

              workhistory['worktyp'] = 'work5';
              workhistory['id'] = admin_id;
              workhistory['name'] = admin_name;
              workhistory['timestamp'] = currentTime.toISOString();

              push(ref(db, 'map/info/workhistory'),workhistory );
              // console.log('way 5')

            }


          }
          dispatch(teamlistData(responsedata));
          if (getpageData != 0) {
            var logocount = 0

            getpageData.responsedata.list.map((ele) => {
              if (ele.logo != "") {
                logocount += 1
              }
            })
            if (logocount >= 2 && values['logo_pic'] != "") {
              var data = {};
              data['work6'] = 3;
              update(ref(db, 'map/info/datastatus/' + aid), data);
              var workhistory = {};
              var currentTime = new Date();  // Store the current time in a variable
              var currentTimeString = currentTime.toLocaleTimeString();
              var currentDateString = currentTime.toLocaleDateString();

              workhistory['worktyp'] = 'work6';
              workhistory['id'] = admin_id;
              workhistory['name'] = admin_name;
              workhistory['date'] = currentDateString;
              workhistory['time'] = currentTimeString;

              push(ref(db, 'map/info/workhistory/' + aid),workhistory );
            }
          }
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          if (savenew == 0) {
            history.push(BASE_PATH + "auction-team");
          } else {
            setCroppedImage("")
            setValue("name", "");
            setValue("srtname", "");
            setValue("srtkey", "");
          }
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        // console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };

  useEffect(() => {
    $(".crop-default img").attr("src", teamdefaultLogo);
    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, [Demo]);
  useEffect(() => {
    const isFirstMount = localStorage.getItem('isFirstMount');
    // console.log('isFirstMount')
    // console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem('isFirstMount', false);
    } else {
      localStorage.removeItem('isFirstMount');
    //   history.push('/auction-detail');
    }
  }, [history]);
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
  }
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row myclass1">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            className="form-control"
                            type="hidden"
                            onWheel={(e) => e.target.blur()}
                            defaultValue={logo}
                            {...register("logo")}
                            id="logo"
                          />

                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="type">
                                    {" "}
                                    Team Logo {/*logo*/}{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <div style={{ clear: "both" }}></div>
                                  <ImageCropper defaultImage={teamdefaultLogo} setCroppedImage={setCroppedImage}/>
                                  <ImageCropper1
                                    croppedImage={croppedImage}
                                    defaultimage={teamdefaultLogo}
                                    setCroppedImage={setCroppedImage}
                                  />   

                                    </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="name"> Team Name * </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    placeholder="Team Name"
                                    type="text"
                                    {...register("name", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.name && (
                                    <p className="text-error">
                                      {errors.name.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="srtname">
                                    {" "}
                                    Team Short Name *{" "}
                                  </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <input
                                    className="form-control"
                                    placeholder="Team Short Name"
                                    type="text"
                                    {...register("srtname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.srtname && (
                                    <p className="text-error">
                                      {errors.srtname.message}
                                    </p>
                                  )}
                                </div>

                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="srtkey">
                                    {" "}
                                    Shortcut Key  *{" "}
                                  </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <select
                                    className="form-control"
                                    type="text"
                                    {...register("srtkey", {
                                      // required: true,
                                      // required: "required field.",
                                    })}
                                  >
                                    <option value="">--select--</option>
                                    {getAlpha()?.map((dt, key) => {
                                      if (getpageData != 0) {
                                        const alphabetsInArray = getpageData.responsedata.list.map(obj => obj.srtkey);
                                        if (!alphabetsInArray.includes(dt)) {

                                          return <option value={dt}>{dt}</option>;
                                        }
                                      }
                                      else {
                                        return <option value={dt}>{dt}</option>;
                                      }
                                    })}
                                  </select>
                                  {errors.srtkey && (
                                    <p className="text-error">
                                      {errors.srtkey.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button"
                                onClick={() => (savenew = 1)}
                                type="submit"
                                style={{ marginLeft: '16px', borderRadius: '8px' }}
                              >
                                Save And Add New
                              </button>
                              <button
                                className="button"
                                onClick={() => (savenew = 0)}
                                type="submit"
                                style={{ marginLeft: '16px', borderRadius: '8px' }}
                              >
                                Add Team
                              </button>

                            </div>
                            {/* <div className="col-md-6">
                              <button
                                className="button secondary"
                                onClick={() => (savenew = 1)}
                                type="submit"
                                style={{ width: "100%" }}
                              >
                                SAVE and New
                              </button>
                            </div> */}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addteam;
  